<template>
  <div class="card">
    <div class="box">
      <div class="list" v-for="(item, index) in list" :key="index">
        <div class="nameBox">
          <div class="stripes"></div>
          <div class="name">{{ item.auName }}</div>
        </div>

        <div class="item">
          <img src="../../../../../static/icon/cardIcon/company.png" alt="" />
          <div class="txt">{{ item.auCompany }}</div>
        </div>

        <div class="item">
          <img src="../../../../../static/icon/cardIcon/depart.png" alt="" />
          <div class="txt">{{ item.auDept }}</div>
        </div>

        <div class="item">
          <img src="../../../../../static/icon/cardIcon/position.png" alt="" />
          <div class="txt">{{ item.auDuty }}</div>
        </div>

        <div class="item">
          <img src="../../../../../static/icon/cardIcon/mobile.png" alt="" />
          <div class="txt">{{ item.auPhone }}</div>
        </div>

        <div class="item">
          <img src="../../../../../static/icon/cardIcon/email@2x.png" alt="" />
          <div class="txt">{{ item.auEmail }}</div>
        </div>
      </div>
    </div>

    <div class="pagination">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="count"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getCardList } from '../../../../../../api/message.js';
export default {
  data() {
    return {
      cardData: {
        pageNo: 1,
        pageSize: 10,
      },
      currentPage: 1,
      list: [],
      count: 0,
    };
  },

  methods: {
    async getList(cardData) {
      let { data } = await getCardList(cardData);
      console.log('卡片列表是：', data);
      if (data.code == 200) {
        this.list = data.data.list;
        this.count = data.data.count;
      } else {
        this.$message({
          showClose: true,
          message: '名片列表获取失败!',
          type: 'error',
        });
      }
    },

    handleCurrentChange(val) {
      this.cardData.pageNo = val;
      this.getList(this.cardData);
    },
  },

  created() {
    this.getList(this.cardData);
  },
};
</script>
<style lang="scss" scoped>
.card {
  width: 100%;
  // padding-top: 30px;

  .box {
    width: 100%;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 290px);
    grid-gap: 10px;
    min-height: 156vw;
    .list {
      margin-bottom: 10px;
      width: 93.5vw;
      height: 60vw;
      background: #ffffff;
      border: 1px solid #e0e0e0;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50%;
        background-image: url('../../../../../static/icon/cardIcon/cardImg.png');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
      }
      .nameBox {
        padding-top: 20px;
        display: flex;
        align-items: center;

        margin-bottom: 25px;
        .stripes {
          width: 5px;
          height: 20px;
          background: #006fb8;
          border-radius: 3px;
          margin-right: 15px;
        }
        .name {
          font-size: 4.8vw;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
        }
      }
      .item {
        width: 100%;
        display: flex;
        padding: 0px 19px;
        align-items: center;
        margin-top: 12px;
        justify-content: space-between;
        box-sizing: border-box;
        img {
          display: block;
          width: 16px;
          height: 16px;
          padding-right: 10px;
        }
        .txt {
          flex: 1;
          font-size: 3.7vw;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          box-sizing: border-box;
        }
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: center;
    padding-top: 50px;
    padding-bottom: 20px;
  }
}
</style>
<style scoped>
.pagination >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  width: 28px;
  height: 28px;
  background: #006fb8;
  border-radius: 6px;
}
.pagination >>> .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  width: 28px;
  height: 28px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: #666666;
}
</style>
